import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../../services/API';

export default function ModalEditarLoja({ 
  show, 
  onClose, 
  loja, 
  onSuccess 
}) {
  const [nomeLoja, setNomeLoja] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (loja) {
      setNomeLoja(loja.loja || '');
    }
  }, [loja]);

  const handleSave = async () => {
    if (!loja) return;

    setSalvando(true);
    try {
      await api.put(`/api/lojas/${loja.cnpj}`, {
        nomeLoja: nomeLoja
      });
      
      toast.success('Loja atualizada com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      onSuccess();
      onClose();
    } catch (error) {
      toast.error('Erro ao atualizar loja', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
    }
    setSalvando(false);
  };

  return (
    <Modal 
      show={show} 
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Loja</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="nomeLoja">Nome da Loja</label>
          <input
            type="text"
            className="form-control"
            id="nomeLoja"
            value={nomeLoja}
            onChange={(e) => setNomeLoja(e.target.value)}
            placeholder="Digite o nome da loja"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSave}
          disabled={salvando}
        >
          {salvando ? 'Salvando...' : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
